/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

const mutations = {
  SET_EXIBIR_MENSAGEM_VEICULO_DESATUALIZADO(state, novoValor) {
      state.exibirMensagemDesatualizado = novoValor;
  },
  LIMPAR_LISTA_VEICULOS(state) {
    state.veiculos = [];
  },
  LIMPAR_ULTIMOS_AVISOS(state) {
    state.ultimosAvisos = [];
  },
  LIMPAR_COR_LOCALIDADE(state) {
    state.corLocalidade = [];
  },
  LIMPAR_LISTA_DIVISAO(state) {
    state.listaDivisao = [];
  },  
  SET_VEICULOS(state, pVeiculos) {
    if (Array.isArray(state.veiculos) && state.veiculos.length ) {      
      try {
          state.veiculos.forEach((va) => {                
            pVeiculos.every((vn) => {        
              if (va.placa === vn.placa) {

                if (va.condutor !== vn.condutor) {
                  va.condutor = vn.condutor;
                }

                if ((va.latitude != vn.latitude) || (va.longitude != vn.longitude)) {										                  
                  va.latitude = vn.latitude;
                  va.longitude = vn.longitude;
                }
                
                if (va.ignicao !== vn.ignicao) {
                  va.ignicao = vn.ignicao;
                  va.velocidadeAtual = vn.velocidadeAtual;
                  va.tempoParado = vn.tempoParado;
                }

                if (va.velocidadeAtual !== vn.velocidadeAtual) {
                  va.velocidadeAtual = vn.velocidadeAtual;
                  va.tempoParado = vn.tempoParado;
                }

                if (va.dataUltimaAtualizacao !== vn.dataUltimaAtualizacao) {
                  va.dataUltimaAtualizacao = vn.dataUltimaAtualizacao;
                }
                
                if (va.dataUltimaAtualizacaoFmt2 !== vn.dataUltimaAtualizacaoFmt2) {
                  va.dataUltimaAtualizacaoFmt2 = vn.dataUltimaAtualizacaoFmt2;
                }

                if (va.tempoSemGPRS !== vn.tempoSemGPRS) {
                  va.tempoSemGPRS = vn.tempoSemGPRS;
                }

                if (va.tempoParado !== vn.tempoParado) {
                  va.tempoParado = vn.tempoParado;
                }

                if (vn.hasOwnProperty("exibirAlertaTempoParado")) {
                  va.exibirAlertaTempoParado = vn.exibirAlertaTempoParado;
                } else if (va.hasOwnProperty("exibirAlertaTempoParado")) {
                  delete va.exibirAlertaTempoParado;
                }

                if (va.isDesatualizado !== vn.isDesatualizado) {
                  va.isDesatualizado = vn.isDesatualizado;
                }

                if (va.orientacao !== vn.orientacao) {
                  va.orientacao = vn.orientacao;
                }
                
                if (va.statusGPRS !== vn.statusGPRS) {
                  va.statusGPRS = vn.statusGPRS;
                }

                if (va.isBloqueado !== vn.isBloqueado) {
                  va.isBloqueado = vn.isBloqueado;
                }
                
                if (va.cidadeAtual !== vn.cidadeAtual) {
                  va.cidadeAtual = vn.cidadeAtual;
                }

                if (va.ultimoOdometro !== vn.ultimoOdometro) {
                  va.ultimoOdometro = vn.ultimoOdometro;
                }

                if (va.ultimoOdometroBkp !== vn.ultimoOdometroBkp) {
                  va.ultimoOdometroBkp = vn.ultimoOdometroBkp;
                }

                if (vn.hasOwnProperty("labelVeiculo")) {
                  va.labelVeiculo = vn.labelVeiculo;
                } else  if (va.hasOwnProperty("labelVeiculo")) {
                  delete va.labelVeiculo;
                }

                if (vn.hasOwnProperty("sensorRS232")) {                
                  va.sensorRS232 = vn.sensorRS232;
                } else if (va.hasOwnProperty("sensorRS232")) {  
                  delete va.sensorRS232;
                }

                if (vn.hasOwnProperty("poi")) {                
                  va.poi = vn.poi;
                } else if (va.hasOwnProperty("poi")) {  
                  delete va.poi;
                }

                if (va.enderecoAtual !== vn.enderecoAtual) {
                  va.enderecoAtual = vn.enderecoAtual;
                }

                if (va.ultimaVoltagem !== vn.ultimaVoltagem) {
                  va.ultimaVoltagem = vn.ultimaVoltagem;
                }

                if (va.semAlimentacaoExterna !== vn.semAlimentacaoExterna) {
                  va.semAlimentacaoExterna = vn.semAlimentacaoExterna;
                }

                if (vn.hasOwnProperty("nivelBateriaModulo")) {                
                  va.nivelBateriaModulo = vn.nivelBateriaModulo;
                } else if (va.hasOwnProperty("nivelBateriaModulo")) {  
                  delete va.nivelBateriaModulo;
                }

                if (va.bateriaAllModulo !== vn.bateriaAllModulo) {                
                  va.bateriaAllModulo = vn.bateriaAllModulo;
                } 

                if (vn.hasOwnProperty("nivelBateriaModuloBkp")) {                
                  va.nivelBateriaModuloBkp = vn.nivelBateriaModuloBkp;
                } else if (va.hasOwnProperty("nivelBateriaModuloBkp")) {  
                  delete va.nivelBateriaModuloBkp;
                } 
                
                if (va.bateriaAllModuloBkp !== vn.bateriaAllModuloBkp) {                
                  va.bateriaAllModuloBkp = vn.bateriaAllModuloBkp;
                } 
                
                if (vn.hasOwnProperty("avisoAux0")) {                
                  va.avisoAux0 = vn.avisoAux0;
                } else if (va.hasOwnProperty("avisoAux0")) {  
                  delete va.avisoAux0;
                }   
                
                if (vn.hasOwnProperty("avisoAux1")) {                
                  va.avisoAux1 = vn.avisoAux1;
                } else if (va.hasOwnProperty("avisoAux1")) {  
                  delete va.avisoAux1;
                } 

                if (vn.hasOwnProperty("avisoAux2")) {                
                  va.avisoAux2 = vn.avisoAux2;
                } else if (va.hasOwnProperty("avisoAux2")) {  
                  delete va.avisoAux2;
                } 

                if (va.statusEntrada1 !== vn.statusEntrada1) {
                  va.statusEntrada1 = vn.statusEntrada1;
                }
                if (va.statusEntrada2 !== vn.statusEntrada2) {
                  va.statusEntrada2 = vn.statusEntrada2;
                }
                if (va.statusEntrada3 !== vn.statusEntrada3) {
                  va.statusEntrada3 = vn.statusEntrada3;
                }
                if (va.statusEntrada4 !== vn.statusEntrada4) {
                  va.statusEntrada4 = vn.statusEntrada4;
                }
                if (va.statusSaida1 !== vn.statusSaida1) {
                  va.statusSaida1 = vn.statusSaida1;
                }
                if (va.statusSaida2 !== vn.statusSaida2) {
                  va.statusSaida2 = vn.statusSaida2;
                }
                if (va.statusSaida3 !== vn.statusSaida3) {
                  va.statusSaida3 = vn.statusSaida3;
                }

                if (va.ultimoRPM !== vn.ultimoRPM) {
                  va.ultimoRPM = vn.ultimoRPM;
                } 
                
                if (vn.hasOwnProperty("capacidadePeso")) {
                  if (va.capacidadePeso !== vn.capacidadePeso) { va.capacidadePeso = vn.capacidadePeso; }
                } else if (va.hasOwnProperty("capacidadePeso")) {
                  delete va.capacidadePeso;
                }
                if (vn.hasOwnProperty("capacidadeVolume")) {
                    if (va.capacidadeVolume !== vn.capacidadeVolume) { va.capacidadeVolume = vn.capacidadeVolume; }
                } else if (va.hasOwnProperty("capacidadeVolume")) {
                  delete va.capacidadeVolume;
                }
                if (vn.hasOwnProperty("condutor")) {
                    if (va.condutor !== vn.condutor) { va.condutor = vn.condutor; }
                } else if (va.hasOwnProperty("condutor")) {
                  delete va.condutor;
                }
                if (vn.hasOwnProperty("autonomia")) {
                    if (va.autonomia !== vn.autonomia) { va.autonomia = vn.autonomia; }
                } else if (va.hasOwnProperty("autonomia")) {
                  delete va.autonomia;
                }
                if (vn.hasOwnProperty("autonomiaPorHora")) {
                    if (va.autonomiaPorHora !== vn.autonomiaPorHora) { va.autonomiaPorHora = vn.autonomiaPorHora; }
                } else if (va.hasOwnProperty("autonomiaPorHora")) {
                  delete va.autonomiaPorHora;
                }
                if (vn.hasOwnProperty("latitude")) {
                    if (va.latitude !== vn.latitude) { va.latitude = vn.latitude; }
                } else if (va.hasOwnProperty("latitude")) {
                  delete va.latitude;
                }
                if (vn.hasOwnProperty("longitude")) {
                    if (va.longitude !== vn.longitude) { va.longitude = vn.longitude; }
                } else if (va.hasOwnProperty("longitude")) {
                  delete va.longitude;
                }
                if (vn.hasOwnProperty("placa")) {
                    if (va.placa !== vn.placa) { va.placa = vn.placa; }
                } else if (va.hasOwnProperty("placa")) {
                  delete va.placa;
                }
                if (vn.hasOwnProperty("panico")) {
                    if (va.panico !== vn.panico) { va.panico = vn.panico; }
                } else if (va.hasOwnProperty("panico")) {
                  delete va.panico;
                }
                if (vn.hasOwnProperty("dataHoraPanico")) {
                    if (va.dataHoraPanico !== vn.dataHoraPanico) { va.dataHoraPanico = vn.dataHoraPanico; }
                } else if (va.hasOwnProperty("dataHoraPanico")) {
                  delete va.dataHoraPanico;
                }
                if (vn.hasOwnProperty("ignicao")) {
                    if (va.ignicao !== vn.ignicao) { va.ignicao = vn.ignicao; }
                } else if (va.hasOwnProperty("ignicao")) {
                  delete va.ignicao;
                }
                if (vn.hasOwnProperty("statusPanico")) {
                    if (va.statusPanico !== vn.statusPanico) { va.statusPanico = vn.statusPanico; }
                } else if (va.hasOwnProperty("statusPanico")) {
                  delete va.statusPanico;
                }
                if (vn.hasOwnProperty("idVeiculo")) {
                    if (va.idVeiculo !== vn.idVeiculo) { va.idVeiculo = vn.idVeiculo; }
                } else if (va.hasOwnProperty("idVeiculo")) {
                  delete va.idVeiculo;
                }
                if (vn.hasOwnProperty("codigoModulo")) {
                    if (va.codigoModulo !== vn.codigoModulo) { va.codigoModulo = vn.codigoModulo; }
                } else if (va.hasOwnProperty("codigoModulo")) {
                  delete va.codigoModulo;
                }
                if (vn.hasOwnProperty("marcaModulo")) {
                    if (va.marcaModulo !== vn.marcaModulo) { va.marcaModulo = vn.marcaModulo; }
                } else if (va.hasOwnProperty("marcaModulo")) {
                  delete va.marcaModulo;
                }
                if (vn.hasOwnProperty("marca")) {
                    if (va.marca !== vn.marca) { va.marca = vn.marca; }
                } else if (va.hasOwnProperty("marca")) {
                  delete va.marca;
                }
                if (vn.hasOwnProperty("modelo")) {
                    if (va.modelo !== vn.modelo) { va.modelo = vn.modelo; }
                } else if (va.hasOwnProperty("modelo")) {
                  delete va.modelo;
                }
                if (vn.hasOwnProperty("tipoVeiculo")) {
                    if (va.tipoVeiculo !== vn.tipoVeiculo) { va.tipoVeiculo = vn.tipoVeiculo; }
                } else if (va.hasOwnProperty("tipoVeiculo")) {
                  delete va.tipoVeiculo;
                }
                if (vn.hasOwnProperty("divisaoVeiculo")) {
                    if (va.divisaoVeiculo !== vn.divisaoVeiculo) { va.divisaoVeiculo = vn.divisaoVeiculo; }
                } else if (va.hasOwnProperty("divisaoVeiculo")) {
                  delete va.divisaoVeiculo;
                }
                if (vn.hasOwnProperty("corNomeDivisao")) {
                    if (va.corNomeDivisao !== vn.corNomeDivisao) { va.corNomeDivisao = vn.corNomeDivisao; }
                } else if (va.hasOwnProperty("corNomeDivisao")) {
                  delete va.corNomeDivisao;
                }
                if (vn.hasOwnProperty("velocidadeAtual")) {
                    if (va.velocidadeAtual !== vn.velocidadeAtual) { va.velocidadeAtual = vn.velocidadeAtual; }
                } else if (va.hasOwnProperty("velocidadeAtual")) {
                  delete va.velocidadeAtual;
                }
                if (vn.hasOwnProperty("dataUltimoPacoteRecebido")) {
                    if (va.dataUltimoPacoteRecebido !== vn.dataUltimoPacoteRecebido) { va.dataUltimoPacoteRecebido = vn.dataUltimoPacoteRecebido; }
                } else if (va.hasOwnProperty("dataUltimoPacoteRecebido")) {
                  delete va.dataUltimoPacoteRecebido;
                }
                if (vn.hasOwnProperty("dataUltimoPacoteRecebidoEmMili")) {
                    if (va.dataUltimoPacoteRecebidoEmMili !== vn.dataUltimoPacoteRecebidoEmMili) { va.dataUltimoPacoteRecebidoEmMili = vn.dataUltimoPacoteRecebidoEmMili; }
                } else if (va.hasOwnProperty("dataUltimoPacoteRecebidoEmMili")) {
                  delete va.dataUltimoPacoteRecebidoEmMili;
                }
                if (vn.hasOwnProperty("dataUltimaAtualizacaoFmt2EmMili")) {
                    if (va.dataUltimaAtualizacaoFmt2EmMili !== vn.dataUltimaAtualizacaoFmt2EmMili) { va.dataUltimaAtualizacaoFmt2EmMili = vn.dataUltimaAtualizacaoFmt2EmMili; }
                } else if (va.hasOwnProperty("dataUltimaAtualizacaoFmt2EmMili")) {
                  delete va.dataUltimaAtualizacaoFmt2EmMili;
                }
                if (vn.hasOwnProperty("tempoSemGPRS")) {
                    if (va.tempoSemGPRS !== vn.tempoSemGPRS) { va.tempoSemGPRS = vn.tempoSemGPRS; }
                } else if (va.hasOwnProperty("tempoSemGPRS")) {
                  delete va.tempoSemGPRS;
                }
                if (vn.hasOwnProperty("tempoParadoEmMinutos")) {
                    if (va.tempoParadoEmMinutos !== vn.tempoParadoEmMinutos) { va.tempoParadoEmMinutos = vn.tempoParadoEmMinutos; }
                } else if (va.hasOwnProperty("tempoParadoEmMinutos")) {
                  delete va.tempoParadoEmMinutos;
                }
                if (vn.hasOwnProperty("isDesatualizado")) {
                    if (va.isDesatualizado !== vn.isDesatualizado) { va.isDesatualizado = vn.isDesatualizado; }
                } else if (va.hasOwnProperty("isDesatualizado")) {
                  delete va.isDesatualizado;
                }
                if (vn.hasOwnProperty("orientacao")) {
                    if (va.orientacao !== vn.orientacao) { va.orientacao = vn.orientacao; }
                } else if (va.hasOwnProperty("orientacao")) {
                  delete va.orientacao;
                }
                if (vn.hasOwnProperty("possuiBloqueio")) {
                    if (va.possuiBloqueio !== vn.possuiBloqueio) { va.possuiBloqueio = vn.possuiBloqueio; }
                } else if (va.hasOwnProperty("possuiBloqueio")) {
                  delete va.possuiBloqueio;
                }
                if (vn.hasOwnProperty("statusGPRS")) {
                    if (va.statusGPRS !== vn.statusGPRS) { va.statusGPRS = vn.statusGPRS; }
                } else if (va.hasOwnProperty("statusGPRS")) {
                  delete va.statusGPRS;
                }
                if (vn.hasOwnProperty("isBloqueado")) {
                    if (va.isBloqueado !== vn.isBloqueado) { va.isBloqueado = vn.isBloqueado; }
                } else if (va.hasOwnProperty("isBloqueado")) {
                  delete va.isBloqueado;
                }
                if (vn.hasOwnProperty("ultimoOdometro")) {
                    if (va.ultimoOdometro !== vn.ultimoOdometro) { va.ultimoOdometro = vn.ultimoOdometro; }
                } else if (va.hasOwnProperty("ultimoOdometro")) {
                  delete va.ultimoOdometro;
                }
                if (vn.hasOwnProperty("ultimoOdometroBkp")) {
                    if (va.ultimoOdometroBkp !== vn.ultimoOdometroBkp) { va.ultimoOdometroBkp = vn.ultimoOdometroBkp; }
                } else if (va.hasOwnProperty("ultimoOdometroBkp")) {
                  delete va.ultimoOdometroBkp;
                }
                if (vn.hasOwnProperty("ultimoHorimetro")) {
                    if (va.ultimoHorimetro !== vn.ultimoHorimetro) { va.ultimoHorimetro = vn.ultimoHorimetro; }
                } else if (va.hasOwnProperty("ultimoHorimetro")) {
                  delete va.ultimoHorimetro;
                }
                if (vn.hasOwnProperty("ultimoHorimetroBkp")) {
                    if (va.ultimoHorimetroBkp !== vn.ultimoHorimetroBkp) { va.ultimoHorimetroBkp = vn.ultimoHorimetroBkp; }
                } else if (va.hasOwnProperty("ultimoHorimetroBkp")) {
                  delete va.ultimoHorimetroBkp;
                }
                if (vn.hasOwnProperty("labelVeiculo")) {
                    if (va.labelVeiculo !== vn.labelVeiculo) { va.labelVeiculo = vn.labelVeiculo; }
                } else if (va.hasOwnProperty("labelVeiculo")) {
                  delete va.labelVeiculo;
                }
                if (vn.hasOwnProperty("possuiTeclado")) {
                    if (va.possuiTeclado !== vn.possuiTeclado) { va.possuiTeclado = vn.possuiTeclado; }
                } else if (va.hasOwnProperty("possuiTeclado")) {
                  delete va.possuiTeclado;
                }
                if (vn.hasOwnProperty("possuiSaida2")) {
                    if (va.possuiSaida2 !== vn.possuiSaida2) { va.possuiSaida2 = vn.possuiSaida2; }
                } else if (va.hasOwnProperty("possuiSaida2")) {
                  delete va.possuiSaida2;
                }
                if (vn.hasOwnProperty("possuiSaida3")) {
                    if (va.possuiSaida3 !== vn.possuiSaida3) { va.possuiSaida3 = vn.possuiSaida3; }
                } else if (va.hasOwnProperty("possuiSaida3")) {
                  delete va.possuiSaida3;
                }
                if (vn.hasOwnProperty("sensorRS232")) {
                    if (va.sensorRS232 !== vn.sensorRS232) { va.sensorRS232 = vn.sensorRS232; }
                } else if (va.hasOwnProperty("sensorRS232")) {
                  delete va.sensorRS232;
                }
                if (vn.hasOwnProperty("sensorRS232Instalado")) {
                    if (va.sensorRS232Instalado !== vn.sensorRS232Instalado) { va.sensorRS232Instalado = vn.sensorRS232Instalado; }
                } else if (va.hasOwnProperty("sensorRS232Instalado")) {
                  delete va.sensorRS232Instalado;
                }
                if (vn.hasOwnProperty("avisarVeiculoLigado")) {
                    if (va.avisarVeiculoLigado !== vn.avisarVeiculoLigado) { va.avisarVeiculoLigado = vn.avisarVeiculoLigado; }
                } else if (va.hasOwnProperty("avisarVeiculoLigado")) {
                  delete va.avisarVeiculoLigado;
                }
                if (vn.hasOwnProperty("avisarVeiculoDesligado")) {
                    if (va.avisarVeiculoDesligado !== vn.avisarVeiculoDesligado) { va.avisarVeiculoDesligado = vn.avisarVeiculoDesligado; }
                } else if (va.hasOwnProperty("avisarVeiculoDesligado")) {
                  delete va.avisarVeiculoDesligado;
                }
                if (vn.hasOwnProperty("statusAncoragem")) {
                    if (va.statusAncoragem !== vn.statusAncoragem) { va.statusAncoragem = vn.statusAncoragem; }
                } else if (va.hasOwnProperty("statusAncoragem")) {
                  delete va.statusAncoragem;
                }
                if (vn.hasOwnProperty("ultimaVoltagem")) {
                    if (va.ultimaVoltagem !== vn.ultimaVoltagem) { va.ultimaVoltagem = vn.ultimaVoltagem; }
                } else if (va.hasOwnProperty("ultimaVoltagem")) {
                  delete va.ultimaVoltagem;
                }
                if (vn.hasOwnProperty("semAlimentacaoExterna")) {
                    if (va.semAlimentacaoExterna !== vn.semAlimentacaoExterna) { va.semAlimentacaoExterna = vn.semAlimentacaoExterna; }
                } else if (va.hasOwnProperty("semAlimentacaoExterna")) {
                  delete va.semAlimentacaoExterna;
                }
                if (vn.hasOwnProperty("nivelBateriaModulo")) {
                    if (va.nivelBateriaModulo !== vn.nivelBateriaModulo) { va.nivelBateriaModulo = vn.nivelBateriaModulo; }
                } else if (va.hasOwnProperty("nivelBateriaModulo")) {
                  delete va.nivelBateriaModulo;
                }
                if (vn.hasOwnProperty("nivelBateriaModuloBkp")) {
                    if (va.nivelBateriaModuloBkp !== vn.nivelBateriaModuloBkp) { va.nivelBateriaModuloBkp = vn.nivelBateriaModuloBkp; }
                } else if (va.hasOwnProperty("nivelBateriaModuloBkp")) {
                  delete va.nivelBateriaModuloBkp;
                }
                if (vn.hasOwnProperty("avisoAux0")) {
                    if (va.avisoAux0 !== vn.avisoAux0) { va.avisoAux0 = vn.avisoAux0; }
                } else if (va.hasOwnProperty("avisoAux0")) {
                  delete va.avisoAux0;
                }
                if (vn.hasOwnProperty("avisoAux1")) {
                    if (va.avisoAux1 !== vn.avisoAux1) { va.avisoAux1 = vn.avisoAux1; }
                } else if (va.hasOwnProperty("avisoAux1")) {
                  delete va.avisoAux1;
                }
                if (vn.hasOwnProperty("avisoAux2")) {
                    if (va.avisoAux2 !== vn.avisoAux2) { va.avisoAux2 = vn.avisoAux2; }
                } else if (va.hasOwnProperty("avisoAux2")) {
                  delete va.avisoAux2;
                }
                if (vn.hasOwnProperty("statusEntrada1")) {
                    if (va.statusEntrada1 !== vn.statusEntrada1) { va.statusEntrada1 = vn.statusEntrada1; }
                } else if (va.hasOwnProperty("statusEntrada1")) {
                  delete va.statusEntrada1;
                }
                if (vn.hasOwnProperty("statusEntrada2")) {
                    if (va.statusEntrada2 !== vn.statusEntrada2) { va.statusEntrada2 = vn.statusEntrada2; }
                } else if (va.hasOwnProperty("statusEntrada2")) {
                  delete va.statusEntrada2;
                }
                if (vn.hasOwnProperty("statusEntrada3")) {
                    if (va.statusEntrada3 !== vn.statusEntrada3) { va.statusEntrada3 = vn.statusEntrada3; }
                } else if (va.hasOwnProperty("statusEntrada3")) {
                  delete va.statusEntrada3;
                }
                if (vn.hasOwnProperty("statusEntrada4")) {
                    if (va.statusEntrada4 !== vn.statusEntrada4) { va.statusEntrada4 = vn.statusEntrada4; }
                } else if (va.hasOwnProperty("statusEntrada4")) {
                  delete va.statusEntrada4;
                }
                if (vn.hasOwnProperty("statusSaida1")) {
                    if (va.statusSaida1 !== vn.statusSaida1) { va.statusSaida1 = vn.statusSaida1; }
                } else if (va.hasOwnProperty("statusSaida1")) {
                  delete va.statusSaida1;
                }
                if (vn.hasOwnProperty("statusSaida2")) {
                    if (va.statusSaida2 !== vn.statusSaida2) { va.statusSaida2 = vn.statusSaida2; }
                } else if (va.hasOwnProperty("statusSaida2")) {
                  delete va.statusSaida2;
                }
                if (vn.hasOwnProperty("statusSaida3")) {
                    if (va.statusSaida3 !== vn.statusSaida3) { va.statusSaida3 = vn.statusSaida3; }
                } else if (va.hasOwnProperty("statusSaida3")) {
                  delete va.statusSaida3;
                }
                if (vn.hasOwnProperty("corVeiculo")) {
                    if (va.corVeiculo !== vn.corVeiculo) { va.corVeiculo = vn.corVeiculo; }
                } else if (va.hasOwnProperty("corVeiculo")) {
                  delete va.corVeiculo;
                }
                if (vn.hasOwnProperty("ultimoRPM")) {
                    if (va.ultimoRPM !== vn.ultimoRPM) { va.ultimoRPM = vn.ultimoRPM; }
                } else if (va.hasOwnProperty("ultimoRPM")) {
                  delete va.ultimoRPM;
                }

                if (vn.hasOwnProperty("panicoAntigo")) {
                    if (va.panicoAntigo !== vn.panicoAntigo) { va.panicoAntigo = vn.panicoAntigo; }
                } else if (va.hasOwnProperty("panicoAntigo")) {
                  delete va.panicoAntigo;
                }

                return false; // para sair do inner loop
              }
              return true;
            });
          });

        } catch(erro1){
          /* eslint-disable no-console */  console.log(erro1);
          /* eslint-disable no-console */  console.log("novosDados=" + pVeiculos);
        }
    } else {      
      state.veiculos = pVeiculos;
    }
  },
  SET_ULTIMOS_AVISOS(state, pAvisos) {
    if (Array.isArray(state.ultimosAvisos) && state.ultimosAvisos.length ) {     
      while (state.ultimosAvisos.length) { state.ultimosAvisos.pop(); } // Removendo todos os itens
    }
    state.ultimosAvisos = pAvisos;
  },
  SET_COR_LOCALIDADE(state, pCorLocalidade) {
    if (Array.isArray(state.corLocalidade) && state.corLocalidade.length ) {     
      while (state.corLocalidade.length) { state.corLocalidade.pop(); } // Removendo todos os itens
    }

    state.corLocalidade = pCorLocalidade;
  },
  MARCAR_AVISO_DISMISSED(state, pAviso) {
    state.ultimosAvisos.forEach((aviso) => {
      if (aviso.id === pAviso.id) {
        aviso.exibirUltimoAviso = false;
      }
    });    
  },
  SET_LISTA_DIVISAO(state, pLista) {
    if (Array.isArray(state.listaDivisao) && state.listaDivisao.length ) {     
      while (state.listaDivisao.length) { state.listaDivisao.pop(); } // Removendo todos os itens
    }
    state.listaDivisao = pLista;
  },
  LIMPAR_LISTA_PEDIDOS_PARA_ROTEIRIZAR(state) {
    state.listaPedidosSelecionadosParaRoteirizar = null;
    state.listaPedidosSelecionadosParaRoteirizar = [];
  },
  INCLUIR_PEDIDOS_PARA_ROTEIRIZAR(state, pLista) {
    if (Array.isArray(state.listaPedidosSelecionadosParaRoteirizar)) {
      state.listaPedidosSelecionadosParaRoteirizar = null;
      state.listaPedidosSelecionadosParaRoteirizar = [];
    }
    
    if (Array.isArray(pLista)) {
      state.listaPedidosSelecionadosParaRoteirizar.push(...pLista);
    } else {
      state.listaPedidosSelecionadosParaRoteirizar.push(pLista);
    }
  },
  INCLUIR_PEDIDO_PARA_ROTEIRIZAR(state, pItem) {
    Vue.set(state.listaPedidosSelecionadosParaRoteirizar, state.listaPedidosSelecionadosParaRoteirizar.length, pItem);
  },
  REMOVER_PEDIDO_PARA_ROTEIRIZAR(state, pItem) {
    state.listaPedidosSelecionadosParaRoteirizar.splice(state.listaPedidosSelecionadosParaRoteirizar.indexOf(pItem), 1);
  },
  SET_DADOS_PARA_PERCURSO(state, pDados) {
    state.dadosParaPercurso = pDados;
  },
  SET_CONFIG_COLUNAS_GRID(state, pDados) {
    state.colunasGrid = pDados;
  },
  SET_CONFIG_COLUNAS_GRID_MAPA(state, pDados) {
    state.colunasGridMapa = pDados;
  },
  SET_CONFIG_COLUNAS_DASHBOARD_TELEMETRIA(state, pDados) {
    state.colunasDashboardTelemetria = pDados;
  },
  SET_CONFIG_MAPA(state, pDados) {
    state.configMapa = pDados;
  },
  SET_MENU_FROTAS_CONFIG_CARDS(state, pDados) {
    state.menuFrotaConfigCards = pDados;
  },

  LIMPAR_LISTA_POI_PARA_ROTEIRIZAR(state) {
    state.listaPoIsSelecionadosParaRoteirizar = null;
    state.listaPoIsSelecionadosParaRoteirizar = [];
  },
  INCLUIR_POIS_PARA_ROTEIRIZAR(state, pLista) {
    if (Array.isArray(state.listaPoIsSelecionadosParaRoteirizar)) {
      state.listaPoIsSelecionadosParaRoteirizar = null;
      state.listaPoIsSelecionadosParaRoteirizar = [];
    }
    
    if (Array.isArray(pLista)) {
      state.listaPoIsSelecionadosParaRoteirizar.push(...pLista);
    } else {
      state.listaPoIsSelecionadosParaRoteirizar.push(pLista);
    }
  },
  INCLUIR_POI_PARA_ROTEIRIZAR(state, pItem) {
    Vue.set(state.listaPoIsSelecionadosParaRoteirizar, state.listaPoIsSelecionadosParaRoteirizar.length, pItem);
  },
  REMOVER_POI_PARA_ROTEIRIZAR(state, pItem) {
    state.listaPoIsSelecionadosParaRoteirizar.splice(state.listaPoIsSelecionadosParaRoteirizar.indexOf(pItem), 1);
  },
  SET_LISTA_CONFIGURACAO_SOM_AVISO(state, pLista) {
    if (Array.isArray(state.listaConfiguracaoSomAviso) && state.listaConfiguracaoSomAviso.length ) {     
      while (state.listaConfiguracaoSomAviso.length) { state.listaConfiguracaoSomAviso.pop(); } // Removendo todos os itens
    }
    state.listaConfiguracaoSomAviso = pLista;
  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val },
  UPDATE_THEME(state, val)           { state.theme             = val },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  SALVAR_DADOS_PARA_RELOGIN(state, payload) {
    state.dadosRelogin = payload;
  },

  APAGAR_DADOS_PARA_RELOGIN(state) {
    state.dadosRelogin = null;
  },

  SALVAR_USUARIO_LOGADO(state, payload) {
    state.AppActiveUser = payload;
  },

  APAGAR_USUARIO_LOGADO(state) {
    state.AppActiveUser = null;
  },

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_NOME_CENTRAL(state, payload) {
    state.nomeCentral = payload;
  },
  SET_FILTRO(state, payload) {
    if (payload.nomeTela === 'roteirizacoes') {
      state.filtrosPesquisa.roteirizacoes = payload.filtro;
    } else if (payload.nomeTela === 'controle-viagens') {
      state.filtrosPesquisa.controleViagens = payload.filtro;
    } else if (payload.nomeTela === 'automatizador-roteirizacao') {
      state.filtrosPesquisa.automatizadorRoteirizacao = payload.filtro;
    } else if (payload.nomeTela === 'despesas') {
      state.filtrosPesquisa.despesas = payload.filtro;
    } else if (payload.nomeTela === 'receitas') {
      state.filtrosPesquisa.receitas = payload.filtro;
    } else if (payload.nomeTela === 'pontoInteresse') {
      state.filtrosPesquisa.pontoInteresse = payload.filtro;
    } else if (payload.nomeTela === 'eventos-monitriip') {
      state.filtrosPesquisa.eventosMonitriip = payload.filtro;
    } else if (payload.nomeTela === 'mensagens-teclado') {
      state.filtrosPesquisa.mensagemTeclado = payload.filtro;
    } else if (payload.nomeTela === 'agenda-evento') {
      state.filtrosPesquisa.agendaEventos = payload.filtro;
    } else if (payload.nomeTela === 'compra-combustivel') {
      state.filtrosPesquisa.comprasCombustivel = payload.filtro;
    } else if (payload.nomeTela === 'tanque-combustivel') {
      state.filtrosPesquisa.tanqueCombustivel = payload.filtro;
    } else if (payload.nomeTela === 'pedidos') {
      state.filtrosPesquisa.pedidos = payload.filtro;
    } else if (payload.nomeTela === 'pneus') {
      state.filtrosPesquisa.pneus = payload.filtro;
    } else if (payload.nomeTela === 'lancamentoAfericao') {
      state.filtrosPesquisa.lancamentoAfericao = payload.filtro;
    } else if (payload.nomeTela === 'compraProduto') {
      state.filtrosPesquisa.compraProduto = payload.filtro;
    } else if (payload.nomeTela === 'ocorrenciaVeiculo') {
      state.filtrosPesquisa.ocorrenciaVeiculo = payload.filtro;      
    } else if (payload.nomeTela === 'integracaoFacchini') {
      state.filtrosPesquisa.integracaoFacchini = payload.filtro;      
    } else if (payload.nomeTela === 'respostasChecklist') {
      state.filtrosPesquisa.respostasChecklist = payload.filtro;      
    } else if (payload.nomeTela === 'motorista') {
      state.filtrosPesquisa.motorista = payload.filtro;      
    } else if (payload.nomeTela === 'veiculos-externos') {
      state.filtrosPesquisa.veiculosExternos = payload.filtro;      
    }     
  }
}

export default mutations

